import React, { Fragment } from "react";
import classes from "./PlanRecommendation.module.scss";
import dompurify from "dompurify";

const planRecommendation = (props) => {
  const sanitizer = dompurify.sanitize;

  return (
    <div className={classes.PlanRecommend}>
      <div className={classes.Title}>We Recommend: </div>
      <div className={classes.planTitle}>
        {props.planRecommendationSelected.plan}
      </div>

      {props.planRecommendationSelected.slug !== "eightyBallpark" ? (
        <div className={classes.priceRange}>
          Price Range {props.planRecommendationSelected.priceRange}
          <br />
          <strong>{props.planRecommendationSelected.avgSavings}</strong> average
          savings off single-game ticket price
          <br />
          <strong className={classes.blurb}>
            {props.planType === "premier"
              ? `Price of the ticket plans includes a $20 per seat processing fee`
              : props.planType === "small"
              ? `Price of the ticket plans set forth below includes a $12.50 processing fee per seat`
              : props.planType === "pickem" &&
                (props.formSize === "eightyFlexible" ||
                  props.formSize === "fortyFlexible")
              ? `Price of the ticket plans includes a $40 processing fee per plan`
              : props.planType === "pickem" &&
                props.formSize === "twentyFlexible"
              ? `Price of the ticket plans includes a $25 processing fee per plan`
              : ``}
          </strong>
          <br />
          <br />
          <div
            className={classes.greenButton}
            onClick={() => props.onClickShowScheduleSelection()}
          >
            {props.planRecommendationSelected.buttonText}
          </div>
          <p
            className={classes.blurb}
            dangerouslySetInnerHTML={{
              __html: sanitizer(props.planRecommendationSelected.blurb),
            }}
          />
          {props.planRecommendationSelected.subBlurb && (
            <p className={classes.blurb}>
              <br />
              <span>{props.planRecommendationSelected.subBlurb} </span>
            </p>
          )}
        </div>
      ) : (
        <div className={classes.priceRange}>
          Price: {props.planRecommendationSelected.priceEnd}
          <br />
          Only <strong>
            {props.planRecommendationSelected.priceStart}
          </strong>{" "}
          per game
          <br />
          <strong className={classes.blurb}>
            Price of the ticket plans includes a $7 per pass processing fee
          </strong>
          <br />
          <br />
          <div
            className={classes.greenButton}
            onClick={() => props.onClickShowScheduleSelection()}
          >
            {props.planRecommendationSelected.buttonText}
          </div>
          <>
            <p
              className={classes.blurb}
              dangerouslySetInnerHTML={{
                __html: sanitizer(props.planRecommendationSelected.blurb),
              }}
            ></p>
            {props.planRecommendationSelected.subBlurb && (
              <p className={classes.blurb}>
                <span>{props.planRecommendationSelected.subBlurb}</span>
              </p>
            )}
          </>
        </div>
      )}
      {((props.planRecommendationSelected.exclusivity?.length ?? 0) > 0 ||
        (props.planRecommendationSelected.savings?.length ?? 0) > 0 ||
        (props.planRecommendationSelected.convenience?.length ?? 0) > 0) && (
        <div className={classes.benefitsWrapper}>
          <div className={classes.benefitTitle}>Benefits</div>

          <div className={classes.benefitListWrapper}>
            <div className={classes.benefitsListItem}>
              <div className={classes.benefitsListItemTitle}>Exclusivity</div>
              <ul>
                {props.planRecommendationSelected.exclusivity?.map(
                  (res, index) => (
                    <li
                      className={
                        res === "Free tickets to September 2024 home games"
                          ? classes.highlight
                          : ""
                      }
                      key={index}
                    >
                      {res}
                    </li>
                  )
                )}
              </ul>
            </div>
            <div className={classes.benefitsListItem}>
              <div className={classes.benefitsListItemTitle}>Savings</div>
              <ul>
                {props.planRecommendationSelected.savings?.map((res, index) => (
                  <li
                    className={
                      res === "Free tickets to September 2024 home games"
                        ? classes.highlight
                        : ""
                    }
                    key={index}
                  >
                    {res}
                  </li>
                ))}
              </ul>
            </div>
            <div className={classes.benefitsListItem}>
              <div className={classes.benefitsListItemTitle}>Convenience</div>
              <ul>
                {props.planRecommendationSelected.convenience?.map(
                  (res, index) => (
                    <li key={index}>{res}</li>
                  )
                )}
              </ul>
            </div>
          </div>
        </div>
      )}
      {/* {props.planRecommendationSelected.slug === "fiveClassic" ? (
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://purchase.tickets.com/buy/MLBEventInfo?agency=WSHN_FLEX103&orgid=17&pid=8800391"
        >
          <div className={classes.greenButton}>Choose my games</div>
        </a>
      ) : ( */}
      <div
        className={classes.greenButton}
        onClick={() => props.onClickShowScheduleSelection()}
      >
        {props.planRecommendationSelected.buttonText}
        {/* {props.planRecommendationSelected.slug === "eightyBallpark"
          ? "Buy Now"
          : "Select My Seats"} */}
      </div>
      {/* )} */}
      <p className={classes.covid19}>
        {/* *50% Bonus Credit calculated based on the amount paid towards qualifying
        new 2021 ticket plans on or before December 15, 2020, less all associated
        fees. For 50% Bonus Credit program terms & conditions, please visit{' '}
        <a
          href="http://www.nationals.com/bonusterms"
          target="_blank"
          rel="noopener noreferrer"
        >
          www.nationals.com/bonusterms
        </a>
        .
        <br />
        <br /> */}
        {/* All 2021 access, benefits, promotions, seating locations, and events
        (including, without limitation, location, dates and times) are subject
        to change without notice based on the ongoing developments of the
        COVID-19 pandemic. */}
      </p>
    </div>
  );
};

export default planRecommendation;
